module.exports = __webpack_public_path__ + "img/maPread_logo_light.b025c722.svg";